import * as React from 'react'
import { useModal } from '@components/modals/use-modal'
import { ButtonWithIcon } from '@components/button-with-icon'

interface Props {
  resortId: number
}

export const CreateImprovementOrder: React.FC<Props> = ({ resortId }) => {
  const [handleIsOpen] = useModal('CreateImprovementOrderModal', { resortId })

  return (
    <div className="ml-auto" style={{ marginTop: -5 }}>
      <ButtonWithIcon
        icon="uil-plus"
        text="Zleć ulepszenie"
        color="green"
        handleClick={handleIsOpen}
        btnClass="btn-tall"
      />
    </div>
  )
}
